import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, KeyValues5, KeyValueSet, LocalService, NumericConfig, PricingManagementInitialization, Status } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';

@Component({
  selector: 'app-product-child-measurement',
  templateUrl: './product-child-measurement.component.html',
  styleUrl: './product-child-measurement.component.scss'
})
export class ProductChildMeasurementComponent {
  @ViewChild('content_product_child_measurement')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["product_config", "table"];
  @Input() productId: string = ''; @Input() businessId: string = ''; @Input() measurementType: number = 0; @Input() countryCode: string = ''; @Input() isNotConsiderTax = false; @Input() isExcludePrice = false;
  @Input() productCode: string = ''; @Input() productName: string = '';
  measurmentTypes: KeyValueSet[] = []; item: KeyValues5; dropdownStyle: string = ''; dropdownWidth = 0;
  parentMeasurmentTypeText = ''; pricing: PricingManagementInitialization;
  @Input() businessTaxCategories: KeyValues5[] = []; @Input() selectedBusinessTaxCategoryId: string = '';
  selectedTab: string = '2';

  message: string = ''; isRedAlert: boolean = true;
  htmlId: string = ''; elementIds: any; items: KeyValues5[] = []; tabs: KeyValueSet[] = [];
  numericConfig: NumericConfig = { isDecimalAllowed: true, isStartWithZeroAllowed: true } as NumericConfig;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      lbl_measure_type: 'lbl_measure_type_' + this.htmlId,
      qty: 'qty_' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right popup_overlay_medium',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad(isOnlyLoad = false) {
    if (!isOnlyLoad) {
      this.onReset();
      this.onLoadTabs();
      this.items = [];
      this.pricing = undefined;
      this.item = {
        isSelected: true,
        v2: ''
      } as KeyValues5;
      this.parentMeasurmentTypeText = this.localService.measurementTypes.find(x => x.key == this.measurementType.toString())?.value ?? '';
      this.measurmentTypes = JSON.parse(JSON.stringify(this.localService.measurementTypes.filter(x => x.key != this.measurementType.toString())));
    }
    
    if (!isOnlyLoad || this.selectedTab == '1')
      this.productManagementService.getChildMeasurementsForProduct(this.productId).subscribe(result => {
        this.items = result;
        if (this.items.length > 0) {
          this.selectedTab = '1';
        }
        this.items.forEach(item => {
          let itemToUpdate = this.measurmentTypes.find(x => x.key == item.v2);
          if (itemToUpdate) {
            itemToUpdate.isSelected = true;
            item.v4 = itemToUpdate.value;
          }
        });
      });
  }

  onLoadTabs() {
    if (this.localService.languageContent && this.localService.languageContent.product_config) {
      this.tabs = [{
        key: '1',
        value: this.localService.languageContent.product_config.active_measurements
      } as KeyValueSet,
      {
        key: '2',
        value: this.localService.languageContent.product_config.edit_measurement
      } as KeyValueSet];
    }
  }

  onReset() {
    this.message = '';
    this.isRedAlert = false;
  }

  onAction(index) {
    switch (index) {
      case 1: {
        this.pricing = undefined;
        this.productManagementService.getChildMeasurementForProduct(this.productId, parseInt(this.item.v2), this.measurementType).subscribe(result => {
          this.item = result;
          this.localService.onFocusNextInput(this.elementIds.qty, FocusInputType.TextBox);
          if (this.item.key) {
            this.onLoadPricing();
          }
        });
      } break;
      case 2: {
        this.productManagementService.saveChildMeasurementForProduct(this.item).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success && !this.item.key) {
            this.item.key = result.id;
            this.onLoadPricing();
          }
        });
      } break;
      case 3: {
        this.productManagementService.savePrice(this.pricing.pricings, this.pricing.pricingsExcluded, this.productId, undefined, parseInt(this.item.v2)).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            if (!this.pricing.detail.isExistingDataAvailable) {
              this.onLoadPricing();
            }
          }
        });
      } break;
    }
  }

  onLoadPricing() {
    this.pricing = undefined;
    this.productManagementService.getPricingManagment(this.businessId, this.productId, undefined, parseInt(this.item.v2), true).subscribe(result => {
      this.pricing = result;
    });
  }
}
